import { ref } from 'vue';
import { generateId } from '../../../cross-app-shared/services/generate-id';

export const toastsActive = ref(
  [] as { id: `toast_${string}`; type: 'success' | 'warning' | 'danger' | 'info'; message: string }[],
);

export function toast({
  type,
  message,
  durationMs = 3000,
}: {
  type: 'success' | 'warning' | 'danger' | 'info';
  message: string;
  durationMs?: number;
}) {
  const id = generateId('toast');
  toastsActive.value.push({ id, type, message });
  setTimeout(() => {
    const index = toastsActive.value.findIndex((t) => t.id === id);
    if (index !== -1) {
      toastsActive.value.splice(index, 1);
    }
  }, durationMs);
}
